import { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { auth, db } from "./config/firebase"; // Ensure `db` is exported in firebase config

const AuthContext = createContext();

// Custom Hook to Use AuthContext
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [application, setApplication] = useState(null); // Store application data
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);

      if (currentUser) {
        const userRef = doc(db, "users", currentUser.uid);
        const currentYear = new Date().getFullYear();
        const applicationRef = doc(
          db,
          "Submissions",
          "ScholarshipApplications",
          currentYear.toString(),
          currentUser.uid
        );

        // Subscribe to user profile updates
        const unsubscribeProfile = onSnapshot(userRef, (docSnap) => {
          if (docSnap.exists()) {
            setProfile(docSnap.data());
          } else {
            console.log("❌ No user profile found");
          }
        });

        // Subscribe to user's scholarship application
        const unsubscribeApplication = onSnapshot(applicationRef, (docSnap) => {
          if (docSnap.exists()) {
            setApplication(docSnap.data());
          } else {
            console.log("❌ No application found");
            setApplication(null);
          }
        });

        return () => {
          unsubscribeProfile(); // Cleanup Firestore listener for profile
          unsubscribeApplication(); // Cleanup Firestore listener for application
        };
      } else {
        setProfile(null);
        setUser(null);
        setApplication(null);
      }
    });

    return () => unsubscribeAuth(); // Cleanup Auth listener on unmount
  }, []);

  return (
    <AuthContext.Provider value={{ user, profile, application, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
